import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  Icon,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  css,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { cssProperties } from "../../utils/commonCssProperties";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import { TbBrowser, TbFileTypeXls } from "react-icons/tb";
import BackButton from "../../common/button/backButton";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import Searchbar from "../../common/searchbar";
import { FaPlus } from "react-icons/fa";
import MasterModel from "./masterModel.js";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import masterFormsActions from "../../redux/masterForms/actions.js";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import courseExamAndBatchActions from "../../redux/courseExamAndBatch/actions.js";
import commonActions from "../../redux/common/actions.js";
import dayjs from "dayjs";
import forcePushAllocationActions from "../../redux/forcePushAllocation/actions.js";
import moment from "moment-timezone";
import JSZip from "jszip";
export default function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
 
  const { driveList } = useSelector((state) => state.masterFormsReducer);

  const { courseListByDrive } = useSelector(
    (state) => state.courseExamAndBatchReducer
  );

  const { showModal } = useSelector((state) => state.commonReducer);

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const { examdateByCourse, examNames } = useSelector(
    (state) => state.forcePushAllocationReducer
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    trigger,
    watch,
    setError,
    clearErrors,
  } = useForm();

  // const [modelOpen, setModelOpen] = useState({
  //   show: false,
  //   type: ''
  // })
  useEffect(() => {
    let startTime = watch("starttime");
    let endTime = watch("endtime");
    if (startTime && endTime) {
      const start = moment(startTime, "HH:mm");
      const end = moment(endTime, "HH:mm");
      const duration = moment(endTime, "HH:mm").diff(
        moment(startTime, "HH:mm"),
        "minute"
      );
      setValue(
        "duration",
        duration
          ? `${String(Math.floor(duration / 60)).padStart(2, "0")}:${String(
              duration % 60
            ).padStart(2, "0")}`
          : ""
      );
    }
  }, [watch("starttime"), watch("endtime"), setValue]);

  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name && name.includes("time")) {
        validateTimeSequence(value);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);


  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_DRIVE });
  }, []);
  const reportingtime=getValues("reportingtime")
  const gateclosingtime=getValues("gateclosingtime")
  const starttime=getValues("starttime")
  const validateTimeSequence = (values) => {
    const { reportingtime, gateclosingtime, starttime, endtime } = values;

    clearErrors("gateclosingtime");
    clearErrors("starttime");
    clearErrors("endtime");

    const toMinutes = (timeStr) => {
      if (!timeStr) return 0;
      const [hours, minutes] = timeStr.split(':').map(Number);
      return hours * 60 + minutes;
    };

    const reportMins = toMinutes(reportingtime);
    const gateCloseMins = toMinutes(gateclosingtime);
    const startMins = toMinutes(starttime);
    const endMins = toMinutes(endtime);

    if (reportingtime && gateclosingtime && gateCloseMins <= reportMins) {
      setError("gateclosingtime", {
        type: "manual",
        message: "Gate closing must be after reporting time"
      });
    }

    if (gateclosingtime && starttime && startMins <= gateCloseMins) {
      setError("starttime", {
        type: "manual",
        message: "Start time must be after gate closing"
      });
    }

    if (starttime && endtime && endMins <= startMins) {
      setError("endtime", {
        type: "manual",
        message: "End time must be after start time"
      });
    }
  };


  const handleModelOpen = (type) => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: type, method: null, data: null },
    });
    // setModelOpen({ show: true, type: type });
  };

  const handleCreateExamDate = (value, handleReset) => {
    dispatch({
      type: courseExamAndBatchActions.CREATE_EXAMDATE,
      payload: {
        data: {
          courseid: parseInt(getValues("courseid")),
          examdate: dayjs(value?.examdate).format("YYYY-MM-DD"),
          userid: parseInt(backofficeTokenDetails?.id),
        },
        handleReset: handleReset,
      },
    });
  };

  const handleCreateExamName = (value, handleReset) => {
    dispatch({
      type: courseExamAndBatchActions.CREATE_EXAM_NAME,
      payload: {
        data: {
          courseid: parseInt(getValues("courseid")),
          examname: value?.examname,
          attemptname: null,
          userid: parseInt(backofficeTokenDetails?.id),
        },
        handleReset: handleReset,
      },
    });
  };

  const handleCreate = (data) => {
    dispatch({
      type: courseExamAndBatchActions.CREATE_EXAM_BATCH,
      payload: {
        data: {
          ...data,
          examnameid: parseInt(data?.examnameid),
          userid: parseInt(backofficeTokenDetails?.id),
        },
        handleReset: reset,
        navigate: navigate,
      },
    });
  };

  return (
    <>
      {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '24px', marginBottom: '14px' }}>
        <Box></Box>
      </Box> */}
      <Grid
        style={{
          padding: "24px",
          // minHeight: "60vh",
          backgroundColor: "#fff",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      >
        <Grid container spacing={2}>
          {/* <Grid container sx={{ display: "felx", flexDirection: "column", border: `1px solid ${cssProperties?.bordercolor?.primary2blue}`, padding: "24px 16px 24px 16px", borderRadius: "4px", justifyContent: "space-between" }}> */}
          {/* <Grid item xs={12} sm={12} md={12} lg={12} > */}
          {/* <Grid container gap={3} > */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}> */}
            <FormControl fullWidth error={!!errors.driveid}>
              <InputLabel id="demo-simple-select-label">Drive Name</InputLabel>
              <Select
                size="small"
                id="demo-simple-select"
                label="Drive Name"
                {...register("driveid", {
                  required: "Drive is required",
                })}
                onChange={(e) => {
                  setValue("driveid", e.target.value);
                  trigger(["driveid"]);
                  dispatch({
                    type: courseExamAndBatchActions.GET_COURSE_BY_DRIVE,
                    payload: { data: parseInt(e.target.value) },
                  });
                }}
                value={watch("driveid") ?? ""}
                sx={{
                  height: "56px",
                }}
              >
                <MenuItem value={""} disabled>
                  --Select--
                </MenuItem>
                {driveList?.all?.map((val, i) => (
                  <MenuItem value={val?.driveid} key={i}>
                    {val?.drivename}
                  </MenuItem>
                ))}
              </Select>
              {errors?.driveid && (
                <FormHelperText style={{ margin: 0 }}>
                  {errors?.driveid?.message}
                </FormHelperText>
              )}
            </FormControl>

            {/* <Button variant='outlined' onClick={() => handleModelOpen('Drive Name')} sx={{ color: "black", borderColor: "#A3A3A3", padding: 1, minWidth: '0', }}
                  ><FaPlus /></Button> */}
            {/* </Box> */}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}> */}
            <FormControl fullWidth error={!!errors.courseid}>
              <InputLabel id="demo-simple-select-label">Add course</InputLabel>
              <Select
                size="small"
                id="demo-simple-select"
                label="Add course"
                {...register("courseid", {
                  required: "Drive is required",
                })}
                disabled={watch("driveid") ? false : true}
                onChange={(e) => {
                  setValue("courseid", e.target.value);
                  trigger(["courseid"]);
                  dispatch({
                    type: forcePushAllocationActions.GET_EXAM_DATES_BY_COURSEID,
                    payload: { courseid: parseInt(e.target.value) },
                  });
                  dispatch({
                    type: forcePushAllocationActions.GET_EXAM_NAMES,
                    payload: { courseid: parseInt(e.target.value) },
                  });
                }}
                value={watch("courseid") ?? ""}
                sx={{
                  height: "56px",
                }}
              >
                <MenuItem value={""} disabled>
                  --Select--
                </MenuItem>
                {courseListByDrive?.map((val, i) => (
                  <MenuItem value={val?.courseid} key={i}>
                    {val?.coursename}
                  </MenuItem>
                ))}
              </Select>
              {errors?.courseid && (
                <FormHelperText style={{ margin: 0 }}>
                  {errors?.courseid?.message}
                </FormHelperText>
              )}
            </FormControl>

            {/* <Button variant='outlined' onClick={() => handleModelOpen('Course')} sx={{ color: "black", borderColor: "#A3A3A3", padding: 1, minWidth: '0', }} ><FaPlus /></Button> */}
            {/* </Box> */}
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              <FormControl fullWidth error={!!errors.courseexamid}>
                <InputLabel id="demo-simple-select-label">
                  Add Exam Date
                </InputLabel>
                <Select
                  size="small"
                  id="demo-simple-select"
                  label="Add Exam Date"
                  {...register("courseexamid", {
                    required: "Exam Date is required",
                  })}
                  onChange={(e) => {
                    setValue("courseexamid", e.target.value);
                    trigger(["courseexamid"]);
                  }}
                  value={watch("courseexamid") ?? ""}
                  disabled={watch("courseid") ? false : true}
                  sx={{
                    height: "56px",
                  }}
                  // inputProps={{style:{height:'56px',boxSizing:'border-box'}}}
                >
                  <MenuItem value={""} disabled>
                    --Select--
                  </MenuItem>
                  {examdateByCourse?.map((val, i) => (
                    <MenuItem value={val?.courseexamid} key={i}>
                      {val?.examdate}
                    </MenuItem>
                  ))}
                </Select>
                {errors?.courseexamid && (
                  <FormHelperText style={{ margin: 0 }}>
                    {errors?.courseexamid?.message}
                  </FormHelperText>
                )}
              </FormControl>
              <Button
                variant="outlined"
                onClick={() => handleModelOpen("Date")}
                sx={{
                  color: "black",
                  borderColor: "#A3A3A3",
                  padding: 1,
                  minWidth: "0",
                  height: "56px",
                }}
                disabled={watch("driveid") && watch("courseid") ? false : true}
              >
                <FaPlus />
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: 2,
              }}
            >
              <FormControl fullWidth error={!!errors.examnameid}>
                <InputLabel id="exam-name-select-label">
                  Exam Name
                </InputLabel>
                <Select
                  size="small"
                  id="exam-name-select"
                  label="Exam Name"
                  {...register("examnameid", {
                    required: "Exam Name is required",
                  })}
                  onChange={(e) => {
                    setValue("examnameid", e.target.value);
                    trigger(["examnameid"]);
                  }}
                  value={watch("examnameid") ?? ""}
                  disabled={watch("courseid") ? false : true}
                  sx={{ height: "56px" }}
                >
                  <MenuItem value={""} disabled>
                    --Select--
                  </MenuItem>
                  {examNames?.map((val, i) => (
                    <MenuItem value={val?.examnameid} key={i}>
                      {val?.examname}
                    </MenuItem>
                  ))}
                </Select>
                {errors?.examnameid && (
                  <FormHelperText style={{ margin: 0 }}>
                    {errors?.examnameid?.message}
                  </FormHelperText>
                )}
              </FormControl>
              <Button
                variant="outlined"
                onClick={() => handleModelOpen("ExamName")}
                sx={{
                  color: "black",
                  borderColor: "#A3A3A3",
                  padding: 1,
                  minWidth: "0",
                  height: "56px",
                }}
                disabled={watch("driveid") && watch("courseid") ? false : true}
              >
                <FaPlus />
              </Button>
            </Box>
          </Grid>


          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              fullWidth
              variant="outlined"
              inputProps={{
                style: { height: "56px", boxSizing: "border-box" },
              }}
              type="text"
              label={
                <span>
                  Batchname
                  <span className="error" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </span>
              }
              placeholder="Enter Batchname"
              {...register("batchname", {
                required: "Batchname is required",
              })}
              error={!!errors.batchname}
              helperText={errors.batchname?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
            />
            {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Add Batch</InputLabel>
                <Select size='small'
                  id="demo-simple-select"
                  label="Add Batch"
                >
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>

              <Button variant='outlined' onClick={() => handleModelOpen('Batch')} sx={{ color: "black", borderColor: "#A3A3A3", padding: 1, minWidth: '0', }}
              ><FaPlus /></Button>
            </Box> */}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              label={
                <span>
                  Select Reporting Time
                  <span className="error" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </span>
              }
              type="time"
              // defaultValue="07:30"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              fullWidth
              {...register("reportingtime", {
                required: "Reporting time is required",
              })}
              error={!!errors.reportingtime}
              helperText={errors.reportingtime?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
            />
          </Grid>
           <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              label={
                <span>
                  Select Gate Closing Time
                  <span className="error" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </span>
              }
              type="time"
              // defaultValue="07:30"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              fullWidth
              {...register("gateclosingtime", {
                required: "Gate closing time is required",
                validate: (value) => {
                  const reportingtime = getValues("reportingtime");
                  if (!reportingtime) return true;
                  
                  const [reportHours, reportMins] = reportingtime.split(':').map(Number);
                  const [gateHours, gateMins] = value.split(':').map(Number);
                  
                  const reportTotal = reportHours * 60 + reportMins;
                  const gateTotal = gateHours * 60 + gateMins;
                  
                  return gateTotal > reportTotal || "Gate closing must be after reporting time";
                }
              })}
              disabled={!reportingtime}
              error={!!errors.gateclosingtime}
              helperText={errors.gateclosingtime?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              label={
                <span>
                  Select Exam Start Time
                  <span className="error" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </span>
              }
              type="time"
              // defaultValue="07:30"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5 min
              }}
              fullWidth
              {...register("starttime", {
                required: "Start time is required",
                validate: (value) => {
                  const gateclosingtime = getValues("gateclosingtime");
                  if (!gateclosingtime) return true;
                  
                  const [gateHours, gateMins] = gateclosingtime.split(':').map(Number);
                  const [startHours, startMins] = value.split(':').map(Number);
                  
                  const gateTotal = gateHours * 60 + gateMins;
                  const startTotal = startHours * 60 + startMins;
                  
                  return startTotal > gateTotal || "Start time must be after gate closing";
                }
              })}
              disabled={!gateclosingtime}
              error={!!errors.starttime}
              helperText={errors.starttime?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              label={
                <span>
                  Select Exam End Time
                  <span className="error" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </span>
              }
              type="time"
              // defaultValue="07:30"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 300, // 5
                views: ["hours", "mitenus"],
                format: "HH:mm",
                ampm: false,
              }}
              fullWidth
              {...register("endtime", {
                required: "End time is required",
                validate: (value) => {
                  const starttime = getValues("starttime");
                  if (!starttime) return true;
                  
                  const [startHours, startMins] = starttime.split(':').map(Number);
                  const [endHours, endMins] = value.split(':').map(Number);
                  
                  const startTotal = startHours * 60 + startMins;
                  const endTotal = endHours * 60 + endMins;
                  
                  return endTotal > startTotal || "End time must be after start time";
                }
              })}
              disabled={!starttime}
              error={!!errors.endtime}
              helperText={errors.endtime?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <TextField
              label={
                <span>
                  Exam Total Duration
                  <span className="error" style={{ color: "red" }}>
                    {" "}
                    *
                  </span>
                </span>
              }
              // type="time"
              // defaultValue="07:30"
              InputLabelProps={{
                shrink: true,
              }}
              readOnly
              inputProps={{
                step: 60, // 5 min
                readOnly: true,
              }}
              fullWidth
              {...register("duration", {
                required: "Duration is required",
              })}
              error={!!errors.duration}
              helperText={errors.duration?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
            />
          </Grid>
         
        


        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          display={"flex"}
          gap={2}
          mt={5}
        >
          {BackButton({
            handleBack: () =>
              navigate(`/${Cookies.get("mhet_mst_project")}/master-list`),
          })}
          {MauvelousPrimaryButton({
            title: "Submit",
            handleClick: handleSubmit(handleCreate),
          })}
        </Grid>
      </Grid>

      {/* </Grid> */}
      {/* </Grid> */}
      <MasterModel
        modelOpen={showModal}
        handleCreateExamDate={handleCreateExamDate}
        handleCreateExamName={handleCreateExamName}
      />
    </>
  );
}
